import { useEffect } from 'react';

export const useRecaptchaBadge = (isEnabled: boolean): void => {
  useEffect(() => {
    const recaptchaBadge = document.querySelector('.grecaptcha-badge') as HTMLElement | null;

    if (!recaptchaBadge) {
      return;
    }

    recaptchaBadge.classList.toggle('visible', isEnabled);

    return () => {
      recaptchaBadge.classList.remove('visible');
    };
  }, [isEnabled]);
};
